/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  SET_ROUNDTABLES (state, roundtables) {
    state.roundtables = roundtables
  },
  SET_ROUNDTABLETOPICS (state, roundtabletopics) {
    state.roundtabletopics = roundtabletopics
  },
  REMOVE_RECORD (state, itemId) {
    const roundtableIndex = state.roundtables.findIndex((u) => u.Email === itemId)
    state.roundtables.splice(roundtableIndex, 1)
  }
}
